import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';

export default function ImageCard({title,body,image , onClick}) {

    const handleClickCard = () => {
        if(onClick){
            onClick();
        }
    }


  return (
    <Card 
    variant={"outlined"}
    onClick={handleClickCard}
    sx={{ 
      boxShadow: '3',
        p:1,
        '&:hover': { boxShadow: '18' , borderColor: '#c5bcbc'}
     }}>
      <CardActionArea>
        <CardContent>
          <Typography gutterBottom component="div">
            {title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {body}
          </Typography>
        </CardContent>
        <CardMedia
          component="img"
          image={image}
          sx={{ height: 140}}
        />
      </CardActionArea>
    </Card>
  );
}